import React, { useState } from "react";
import "./Projects.css";
import { IoCloseCircle } from "react-icons/io5";
import { IoMdPhotos } from "react-icons/io";
import PageHeading from "../../components/client/common/widgets/PageHeading/PageHeading";
import { Helmet } from "react-helmet-async";

const projects = [
  {
    name: "Shelter of Our Dreams",
    location: "Chengannur, Pathanamthitta, Kerala ",
    description: "New Home",
    thumbnail: require("../../assets/images/projects/new-04-04-25-chengannur/main.jpg"),
    gallery: [
      {
        img: require("../../assets/images/projects/new-04-04-25-chengannur/1.home.jpg"),
        label: "Home",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-chengannur/2.entrance.jpg"),
        label: "Entrance",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-chengannur/3.courtyard.jpg"),
        label: "Courtyard",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-chengannur/4.courtyard-view.jpg"),
        label: "Courtyard",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-chengannur/5.verandah.jpg"),
        label: "Verandah",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-chengannur/6.main-living.jpg"),
        label: "Living",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-chengannur/7.dining-hall.jpg"),
        label: "Dining",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-chengannur/10.dining-wash.jpg"),
        label: "Dining and Wash Area",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-chengannur/8.kitchen.jpg"),
        label: "Kitchen",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-chengannur/9.kitchen-alcove.jpg"),
        label: "Kitchen - Breakfast Alcove",
      },

      {
        img: require("../../assets/images/projects/new-04-04-25-chengannur/11.indoor-courtyard.jpg"),
        label: "Indoor Courtyard",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-chengannur/12.upstairs-living.jpg"),
        label: "Upstair Living",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-chengannur/13.bedroom.jpg"),
        label: "Bedroom",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-chengannur/14.bedroom.jpg"),
        label: "Bedroom",
      },

      {
        img: require("../../assets/images/projects/new-04-04-25-chengannur/15.bedroom.jpg"),
        label: "Bedroom",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-chengannur/16.bedroom.jpg"),
        label: "Bedroom",
      },
    ],
  },
  {
    name: "Stone by Stone",
    location: "Vazhakkulam, Ernakulam, Kerala ",
    description: "New Home",
    thumbnail: require("../../assets/images/projects/new-04-04-25-anil/main.jpg"),
    gallery: [
      {
        img: require("../../assets/images/projects/new-04-04-25-anil/home.jpg"),
        label: "Home",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-anil/outdoor.jpg"),
        label: "Outdoor",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-anil/entrance.jpg"),
        label: "Entrance",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-anil/view.jpg"),
        label: "View",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-anil/outdoor perspective.jpg"),
        label: "Outdoor Perspective",
      },
      {
        img: require("../../assets/images/projects/new-04-04-25-anil/home view.jpg"),
        label: "Home View",
      },
    ],
  },
  {
    name: "Vision to Haven",
    location: "Kerala, India",
    description: "New Home",
    thumbnail: require("../../assets/images/projects/new-16-02-25-ali/main.jpg"),
    gallery: [
      {
        img: require("../../assets/images/projects/new-16-02-25-ali/home.jpg"),
        label: "Home Sweethome",
      },
      {
        img: require("../../assets/images/projects/new-16-02-25-ali/1-outdoor.jpg"),
        label: "Entrances",
      },

      {
        img: require("../../assets/images/projects/new-16-02-25-ali/2-outdoor.jpg"),
        label: "West View",
      },
      {
        img: require("../../assets/images/projects/new-16-02-25-ali/3-outdoor.jpg"),
        label: "West View",
      },
      {
        img: require("../../assets/images/projects/new-16-02-25-ali/4-outdoor.jpg"),
        label: "Outdoor View",
      },
      {
        img: require("../../assets/images/projects/new-16-02-25-ali/5-outdoor.jpg"),
        label: "Collage Outdoor",
      },
      {
        img: require("../../assets/images/projects/new-16-02-25-ali/6-sitout.jpg"),
        label: "Sitout",
      },
      {
        img: require("../../assets/images/projects/new-16-02-25-ali/7-living.jpg"),
        label: "Living Stair",
      },
    ],
  },
  {
    name: "Built to Belong",
    location: "Kumbanad, Pathanamthitta, Kerala",
    description: "New Home",
    thumbnail: require("../../assets/images/projects/new-13-02-25-sooraj/main.jpg"),
    gallery: [
      {
        img: require("../../assets/images/projects/new-13-02-25-sooraj/home.jpg"),
        label: "Home Sweethome",
      },
      {
        img: require("../../assets/images/projects/new-13-02-25-sooraj/entrance.jpg"),
        label: "Entrances",
      },

      {
        img: require("../../assets/images/projects/new-13-02-25-sooraj/living.jpg"),
        label: "Living",
      },
      {
        img: require("../../assets/images/projects/new-13-02-25-sooraj/dining.jpg"),
        label: "Dining",
      },
      {
        img: require("../../assets/images/projects/new-13-02-25-sooraj/sitout-outdoor.jpg"),
        label: "Sitout Outdoor",
      },
      {
        img: require("../../assets/images/projects/new-13-02-25-sooraj/bathroom.jpg"),
        label: "bathroom / Toilet",
      },
      {
        img: require("../../assets/images/projects/new-13-02-25-sooraj/kitchen.jpg"),
        label: "Kitchen",
      },
      {
        img: require("../../assets/images/projects/new-13-02-25-sooraj/first-floor.jpg"),
        label: "Indoor First Floor",
      },
      {
        img: require("../../assets/images/projects/new-13-02-25-sooraj/view-outdoor.jpg"),
        label: "Outdoor View",
      },
    ],
  },
  {
    name: "Home Makeover",
    location: "Kumbanad, Pathanamthitta, Kerala",
    description: "Renovation",
    thumbnail: require("../../assets/images/projects/villa-1/main.jpg"),
    gallery: [
      {
        img: require("../../assets/images/projects/villa-1/reno_image-1.jpg"),
        label: "Retro / Modern",
      },
      {
        img: require("../../assets/images/projects/villa-1/reno_image-2.jpg"),
        label: "Renovation / Modification",
      },

      {
        img: require("../../assets/images/projects/villa-1/reno_image-3.jpg"),
        label: "Foyer",
      },
      {
        img: require("../../assets/images/projects/villa-1/reno_image-4.jpg"),
        label: "Living",
      },
    ],
  },
  {
    name: "Home, Finally Ours",
    location: "Eraviperoor, Pathanamthitta, Kerala ",
    description: "Renovation",
    thumbnail: require("../../assets/images/projects/renovation-1/main.jpg"),
    gallery: [
      {
        img: require("../../assets/images/projects/renovation-1/home-Front.jpg"),
        label: "Home",
      },
      {
        img: require("../../assets/images/projects/renovation-1/before-after-1.jpg"),
        label: "Before - After",
      },
      {
        img: require("../../assets/images/projects/renovation-1/before.jpg"),
        label: "Before Renovation",
      },
      {
        img: require("../../assets/images/projects/renovation-1/renovation.jpg"),
        label: "On the Road",
      },
      {
        img: require("../../assets/images/projects/renovation-1/porch.jpg"),
        label: "Car Porch",
      },
      {
        img: require("../../assets/images/projects/renovation-1/courtyard.jpg"),
        label: "Courtyard",
      },

      {
        img: require("../../assets/images/projects/renovation-1/before-after-2.jpg"),
        label: "Before - After",
      },
    ],
  },
];

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const handleGalleryOpen = (project) => {
    setSelectedProject(project);
    setSelectedImageIndex(0);
  };

  const handleGalleryClose = () => {
    // console.log("Close button clicked"); // Debug log
    setSelectedProject(null);
  };

  const handleNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === selectedProject.gallery.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrev = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? selectedProject.gallery.length - 1 : prevIndex - 1
    );
  };

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal")) {
      console.log("from out");
      handleGalleryClose();
    }
  };

  return (
    <div className="page-section">
      <Helmet>
        <title>Our Projects - EAMSQUARE Pvt Ltd</title>
        <meta
          name="description"
          content="Explore our completed projects at EAMSQUARE, showcasing our expertise in construction."
        />
        <meta
          name="keywords"
          content="construction projects, EAMSQUARE, civil engineering, completed projects, Kerala"
        />
      </Helmet>
      <PageHeading title="our projects" highlight="projects" />
      <div className="projects-page-container">
        {projects.map((project, index) => (
          <div key={index} className="project-card">
            <IoMdPhotos
              className="icon_gallery"
              title="View Gallery"
              onClick={() => handleGalleryOpen(project)}
            />
            <img
              src={project.thumbnail}
              alt={project.name}
              className="project-thumbnail"
              onClick={() => handleGalleryOpen(project)}
            />
            <div className="project-details">
              <h3>{project.name}</h3>
              <p>{project.location}</p>
              <p className="project-category">{project.description}</p>
            </div>
          </div>
        ))}
      </div>

      {selectedProject && (
        <div className="modal" onClick={handleOutsideClick}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <IoCloseCircle className="close" onClick={handleGalleryClose} />

            <div className="modal-gallery">
              <button className="prev" onClick={handlePrev}>
                &#8249;
              </button>
              <img
                src={selectedProject.gallery[selectedImageIndex].img}
                alt={`Gallery ${selectedImageIndex + 1}`}
                className="main-image"
              />
              <div className="image-label">
                {selectedProject.gallery[selectedImageIndex].label}
              </div>
              <button className="next" onClick={handleNext}>
                &#8250;
              </button>
            </div>
            <div className="thumbnail-container">
              {selectedProject.gallery.map((image, idx) => (
                <img
                  key={idx}
                  src={image.img}
                  alt={`Thumbnail ${idx + 1}`}
                  className={`thumbnail ${
                    idx === selectedImageIndex ? "active" : ""
                  }`}
                  onClick={() => setSelectedImageIndex(idx)}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Projects;
